const getConfigEnv = (region = '') => {
  const host = window.location.hostname;
  const regionsConfig = {
    ...process.env.REGIONS.split(',').reduce(
      (acum, regionName) => ({
        ...acum,
        [regionName.toLowerCase()]: {
          skin: process.env[`${regionName}_SKIN`],
          ...(process.env[`${regionName}_LANG`] && {
            lang: process.env[`${regionName}_LANG`],
          }),
        },
      }),
      {},
    ),
  };

  return {
    origin: `https://${host}/`,
    api_version: process.env.API_VERSION,
    app_key: process.env.APP_KEY,
    authpn: process.env.AUTHPN,
    authpt: process.env.AUTHPT,
    facebook_app_id: process.env.FACEBOOK_APP_ID,
    start_header_info_domain: process.env.START_HEADER_INFO_DOMAIN,
    urlPlayer: {
      chrome: `https://${host}${process.env.URL_PLAYER_CHROME}`,
      edge: `https://${host}${process.env.URL_PLAYER_EDGE}`,
      default: `https://${host}${process.env.URL_PLAYER_DEFAULT}`,
      firefox: `https://${host}${process.env.URL_PLAYER_FIREFOX}`,
      safari: `https://${host}${process.env.URL_PLAYER_SAFARI}`,
    },
    url_dominio_microfwk: process.env.URL_DOMINIO_MICROFWK,
    url_dominio_microfwka_hbo: process.env.URL_DOMINIO_MICROFWK_HBO,
    url_middleware_claro_musica: process.env.URL_MIDDLEWARE_CLARO_MUSICA,
    config: {
      allow_origin: {
        playerhtml5: `http://${host}`,
        playeredge: `http://${host}`,
        webclient: `https://${host}`,
        webclient_nonssl: `http://${host}`,
      },
      general: {
        api_params_default: {
          api_version: process.env.API_VERSION,
          authpn: process.env.AUTHPN,
          authpt: process.env.AUTHPT,
          device_category: process.env.DEVICE_CATEGORY,
          device_id: process.env.DEVICE_ID,
          device_manufacturer: process.env.DEVICE_MANUFACTURER,
          device_model: process.env.DEVICE_MODEL,
          device_type: process.env.DEVICE_TYPE,
          format: process.env.FORMAT,
        },
      },
      start_header_info_params: `?device_id=${
        process.env.DEVICE_ID
      }&device_category=${process.env.DEVICE_CATEGORY}&device_manufacturer=${
        process.env.DEVICE_MANUFACTURER
      }&device_model=${process.env.DEVICE_MODEL}&device_type=${
        process.env.DEVICE_TYPE
      }&api_version=${process.env.API_VERSION}&authpn=${
        process.env.AUTHPN
      }&authpt=${process.env.AUTHPT}&format=${process.env.FORMAT}`,
      regions: {
        region: regionsConfig,
        region_default: process.env.REGION_DEFAULT,
        region_default_lang: process.env.REGION_DEFAULT_LANG,
        region_default_skin: process.env.REGION_DEFAULT_SKIN,
      },
    },
    lang:
      process.env[`${region.toUpperCase()}_LANG`] ||
      process.env.REGION_DEFAULT_LANG,
    skin:
      process.env[`${region.toUpperCase()}_SKIN`] ||
      process.env.REGION_DEFAULT_SKIN,

    end_point_apa: process.env.ENDPOINT_APA,
  };
};

export default getConfigEnv;
